<div class="flex flex-col gap-2">
  @if (label()) {
    <label [for]="inputId()">{{ label() | translateKey }}</label>
  }

  <input
    pInputText
    [id]="inputId()"
    [type]="type()"
    [attr.maxlength]="maxLength()"
    [attr.inputmode]="inputMode()"
    [attr.pattern]="numericOnly() ? '[0-9]*' : null"
    [placeholder]="placeholderValue()"
    [value]="value()"
    [disabled]="disabled()"
    [readOnly]="readOnly()"
    (input)="onInputText($event)"
    (blur)="onBlur()"
    [ngClass]="{
      'ng-invalid ng-dirty': hasErrorSignal(),
      'w-full': fullWidth(),
    }"
  />

  @if (hasErrorSignal()) {
    <app-form-field-error [controlName]="ngControl"></app-form-field-error>
  }
</div>
